<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="1200px"
            transition="false"
            content-class="v-dialog--large"
        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("tasksHistory") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-progress-linear color="green" :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>

                <v-toolbar card prominent dense>
                    {{ $t("showCalculations") }}:
                    <v-radio-group row v-model="showCalculations" class="mt-3 ml-2">
                        <v-radio :label="$t('my')" value="my"></v-radio>
                        <v-radio :label="$t('all')" value="all"></v-radio>
                    </v-radio-group>
                </v-toolbar>

                <v-card-text class="pa-0">
                    <v-layout row wrap>
                        <v-flex
                            xs3
                            class="text-sm-left text-xs-center"
                        >
                            <v-btn @click="$refs.calendar.prev()">
                                <v-icon dark left>keyboard_arrow_left</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center headline mt-1">
                            <template v-if="start.substring(5, 7) == 1">{{ $t("monthsList.january")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 2">{{ $t("monthsList.february")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 3">{{ $t("monthsList.march")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 4">{{ $t("monthsList.april")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 5">{{ $t("monthsList.may")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 6">{{ $t("monthsList.june")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 7">{{ $t("monthsList.july")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 8">{{ $t("monthsList.august")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 9">{{ $t("monthsList.september")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 10">{{ $t("monthsList.october")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 11">{{ $t("monthsList.november")}} {{ start.substring(0, 4) }}</template>
                            <template v-if="start.substring(5, 7) == 12">{{ $t("monthsList.december")}} {{ start.substring(0, 4) }}</template>
                        </v-flex>
                        <v-flex
                            xs3
                            class="text-sm-right text-xs-center"
                        >
                            <v-btn @click="$refs.calendar.next()">
                                <v-icon right dark>keyboard_arrow_right</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-divider/>
                    <v-layout row wrap>
                        <v-flex xs12 lg7 px-9 class="calendar-container">
                            <v-calendar
                                :now="today"
                                :value="today"
                                :locale="locale"
                                :weekdays="weekdays"
                                v-model="start"
                                color="primary"
                                ref="calendar"
                                @click:date="getTasks(start)"
                            >
                                <template v-slot:day="{ date }">
                                    <v-sheet
                                        v-for="(event, index) in eventsMap[date]"
                                        :key="index"
                                        class="event"
                                        @click="getTasks(event.date)"
                                    >{{ event.title }}</v-sheet>
                                </template>
                            </v-calendar>
                        </v-flex>
                        <v-flex xs12 md4 lg5 pl-3>
                            <v-layout row wrap>
                                <v-flex class="title my-2">{{ selectedDate }}</v-flex>
                            </v-layout>
                            <v-container class="internal-container pl-0">
                                <v-list>
                                    <v-list-tile
                                        v-for="(task, index) in filteredTasks"
                                        :key="index"
                                        @click="loadTask(task.id)"
                                    >
                                        {{ index + 1 }}. {{ task.time.substring(0, 8) }} - {{ task.userName }}
                                    </v-list-tile>
                                </v-list>
                            </v-container>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="dialog = false">{{ $t("close") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "TaskHistoryDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog: false,

                dataLoaded:         [],
                events:             [],
                id:                 null,
                locale:             "en-us",
                progressBarVisible: false,
                start:              "2021-01-01",
                selectedDate:       null,
                showCalculations:   "my",
                firstRun:           true,
                tasks:              [],
                taskType:           1,
                today:              null,
                weekdays:           [0, 1, 2, 3, 4, 5, 6]
            }
        },

        computed: {
            // convert the list of events into a map of lists keyed by date
            eventsMap () {
                const map = {};
                this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
                //return map;
                //return Object.filter(map, elm => (this.showCalculations == "my" && parseInt(elm[0].userId) == parseInt(this.$store.getters.user.id)) || this.showCalculations !== "my");
                //return Object.filter(map, elm => (this.showCalculations == "my" && elm[0].userId == this.$store.getters.user.id) || this.showCalculations !== "my");
                return Object.filter(map, elm => (this.showCalculations == "my" && elm.filter(t => t.userId == this.$store.getters.user.id).length > 0 || this.showCalculations !== "my"));
            },

            filteredTasks () {
                return this.tasks.filter(t => {
                    return (this.showCalculations == "my" && t.userId == this.$store.getters.user.id) || this.showCalculations !== "my";
                });
            }
        },

        watch: {
            dialog: function (val) {
                this.$debug.log("watch dialog", val);

                if (val) {
                    this.events     = [];
                    this.dataLoaded = [];
                    this.firstRun   = true;

                    this.$debug.log("watch dialog", val, this);
                    //this.getCalendar();
                    let today = (new Date).toISOString();
                    this.getMonthCalendar(today.substring(0, 4), today.substring(5, 7));
                    this.getMonthCalendar(today.substring(0, 4), today.substring(5, 7) - 1);

                    this.start = today; //(new Date).toISOString();
                    this.getTasks(this.start);
                }
            },

            showCalculations: function (val) {
                localStorage.showCalculations = val;
            },

            start: function (val) {
                if (!this.firstRun) {
                    this.getMonthCalendar(val.substring(0, 4), val.substring(5, 7));
                    this.getMonthCalendar(val.substring(0, 4), val.substring(5, 7) - 1);
                }
            }
        },

        async mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.showCalculations = localStorage.showCalculations ? localStorage.showCalculations : "my";

            this.applyLocale();
            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            /*
            this.getCalendar();

            this.start = (new Date).toISOString();
            this.getTasks(this.start);
            */
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                if (this.$i18n.locale == "ru") {
                    this.locale = "ru-ru";
                    this.weekdays = [1, 2, 3, 4, 5, 6, 0];
                } else { //"en"
                    this.locale = "en-us";
                    this.weekdays = [0, 1, 2, 3, 4, 5, 6];
                }
            },

            /**
             * Загрузка данных календаря
             */
            /*
            getCalendar () {
                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}tasks/calendar/${this.taskType}/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let receivedData = response.data.dates;

                            this.progressBarVisible = false;

                            this.events = [];

                            receivedData.forEach((data) => {
                                if (this.events.filter(t => t.date == data.date).length == 0
                                    || (this.events.filter(t => t.date == data.date).length == 1 && data.UserId == this.$store.getters.user.id)
                                    || (this.events.filter(t => t.date == data.date).length == 1 && this.events.filter(t => t.userId == this.$store.getters.user.id).length == 1)
                                ) {
                                    this.events.push({
                                        title:  data.UserId == this.$store.getters.user.id ? this.$t("hasMyCalculations") : this.$t("hasCalculations"),
                                        date:   data.date,
                                        userId: data.UserId
                                    });
                                }
                            });
                        }
                    })
                    .catch(err => {
                        this.progressBarVisible = false;
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadEventsData"));

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `TasksHistoryDialog.vue -> getCalendar: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
            },
            */

            /**
             * Загрузка данных календаря
             *
             * @param {number} year  Год
             * @param {number} month Месяц
             */
            async getMonthCalendar (year, month) {
                //if (this.dataLoaded[year] !== undefined && this.dataLoaded[year][month]) {
                if (this.dataLoaded.includes(`${year}-${month}`)) {
                    return;
                }

                this.progressBarVisible = true;

                let component = this;

                await this.axios.get(`${this.$config.apiURL}tasks/calendar/${year}/${month}/${this.taskType}/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let receivedData = response.data.dates;

                            this.progressBarVisible = false;

                            //this.events = [];

                            receivedData.forEach((data) => {
                                if (this.events.filter(t => t.date == data.date).length == 0
                                    || (this.events.filter(t => t.date == data.date).length == 1 && data.UserId == this.$store.getters.user.id)
                                    || (this.events.filter(t => t.date == data.date).length == 1 && this.events.filter(t => t.userId == this.$store.getters.user.id).length == 1)
                                ) {
                                    this.events.push({
                                        title:  data.UserId == this.$store.getters.user.id ? this.$t("hasMyCalculations") : this.$t("hasCalculations"),
                                        date:   data.date,
                                        userId: data.UserId
                                    });
                                }
                            });

                            component.dataLoaded.push(`${year}-${month}`);

                            this.firstRun = false;
                        }
                    })
                    .catch(err => {
                        this.progressBarVisible = false;

                        this.showMessageBox(this.$t("error"), this.$t("cantLoadEventsData"));

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `TasksHistoryDialog.vue -> getCalendar: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
            },

            /**
             * Загрузка задач
             *
             * @param {string} date Дата
             */
            getTasks (date) {
                this.selectedDate = new Date(date).toLocaleDateString();

                this.progressBarVisible = true;

                this.axios.get(`${this.$config.apiURL}tasks/calendar/${date}/${this.taskType}/`, { withCredentials: true })
                    .then(response => {
                        this.progressBarVisible = false;

                        if (response.data.status == "success") {
                            let receivedData = response.data.tasks;

                            this.tasks = [];

                            receivedData.forEach((data) => {
                                let timeWithMs = new Date(data.createdAt).toLocaleTimeString().substring(0, 8)
                                    + "." + new Date(data.createdAt).getMilliseconds()
                                //if (this.tasks.filter(t => t.time.substring(0, 10) == new Date(data.createdAt).toLocaleTimeString().substring(0, 10)).length == 0) {
                                if (this.tasks.filter(t => t.time.substring(0, 12) == timeWithMs).length == 0) {
                                    this.tasks.push({
                                        id:       data.id,
                                        time:     timeWithMs, //new Date(data.createdAt).toLocaleTimeString(),
                                        userId:   data.User.id,
                                        userName: (data.User.FirstName.trim() !== "" ? data.User.FirstName.trim().charAt(0) + "." : "") + //(data.User.FirstName.trim() !== "" ? data.User.FirstName.trim() + " " : "") +
                                                    (data.User.MiddleName.trim() !== "" ? data.User.MiddleName.trim().charAt(0) + ". " : "") +
                                                    (data.User.LastName.trim() !== "" ? data.User.LastName.trim() + " " : "")
                                    });
                                } else {
                                    this.$debug.log(new Date(data.createdAt).toLocaleTimeString().substring(0, 10));
                                    this.$debug.log(new Date(data.createdAt).toLocaleTimeString());
                                }
                            });
                        }
                    })
                    .catch(err => {
                        this.progressBarVisible = false;

                        this.showMessageBox(this.$t("error"), this.$t("cantLoadTasksData"));

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `TasksHistoryDialog.vue -> getTasks: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });
                    });
            },

            /**
             * Загрузка задания
             *
             * @param {number} id Идентификатор задания
             */
            loadTask (id) {
                this.id     = id;
                this.dialog = false;
            },

            /**
             * Отображает сообщение
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .event
        cursor: pointer

    .internal-container
        height: 416px
        overflow-y: auto

    .calendar-container
        height: 452px
        overflow-y: auto
</style>
